// Réglages sonores du mixer : une seule lecture pour tout le monde.
//
// AudioMixer pilote les changements en direct, mais il n'est monté que sur la
// page You : avant, un réglage sauvegardé n'atteignait le moteur qu'une fois
// cette page ouverte dans la session. Depuis que la réverbération est commune,
// sa durée touche toutes les sources, et le défaut s'entendait partout. Le
// démarrage lit donc ici la même clé avec le même défaut que le mixer.
//
// Lecture À L'USAGE, jamais figée à l'import : le miroir user est hydraté après
// l'évaluation des modules (cf userStore, même patron que eqProcessor).
import { getSetting } from '../data/userStore';

export const REVERB_DECAY_KEY = 'reverbDecay';
export const REVERB_MIX_KEY = 'reverbMix';
export const DEGREE_VOLUMES_KEY = 'degreeVolumesDb';

// Durée commune de la réverbération, en secondes. Valeur de départ : celle des
// pianos, la source la plus exposée (cf reverbBus).
export const REVERB_DECAY = 3;

// Dosage direct/effet de la nappe.
export const REVERB_MIX = 0.4;

// Degrés d'accord du Note Mixer. Défauts choisis pour que le bourdon garde son
// +5 dB et les notes d'accord l'unité (0 dB).
export const DEGREE_MIN_DB = -40;
export const DEGREE_DEFAULTS_DB = { drone: 5, root: 0, third: 0, fifth: 0, seventh: 0 };

// dB -> gain linéaire. Au plancher du curseur, silence complet.
export const dbToGain = (db) => (db <= DEGREE_MIN_DB ? 0 : Math.pow(10, db / 20));

// Une valeur impossible (curseur corrompu, réglage venu d'une vieille version)
// retombe sur le défaut plutôt que de casser l'effet.
export const savedReverbDecay = () => {
  const saved = getSetting(REVERB_DECAY_KEY, REVERB_DECAY);
  return Number.isFinite(saved) && saved > 0 ? saved : REVERB_DECAY;
};

export const savedReverbMix = () => {
  const saved = getSetting(REVERB_MIX_KEY, REVERB_MIX);
  return Number.isFinite(saved) && saved >= 0 && saved <= 1 ? saved : REVERB_MIX;
};

// Gains linéaires des seuls degrés RÉELLEMENT sauvegardés : un degré jamais
// touché garde le défaut du moteur, on ne lui repousse pas une valeur qui ne
// vient pas de l'utilisateur.
export const savedDegreeGains = () => {
  const saved = getSetting(DEGREE_VOLUMES_KEY, null);
  const gains = {};
  if (!saved || typeof saved !== 'object') return gains;
  for (const key of Object.keys(DEGREE_DEFAULTS_DB)) {
    if (Number.isFinite(saved[key])) gains[key] = dbToGain(saved[key]);
  }
  return gains;
};
